<template>
<div>

  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <div class="flex flex-wrap -mx-2">
      <div class="w-full md:w-1/2 px-2">
        <div class="box">

          <div class="flex flex-wrap -mx-1">
            <div class="px-1">
              <label class="block text-xs font-bold mb-2" for="title">
                Title
              </label>
              <div class="relative">
                <select
                  class="form-control pr-8"
                  id="title"
                  v-model="contact.title"
                >
                  <option></option>
                  <option value="mr">Mr</option>
                  <option value="mrs">Mrs</option>
                  <option value="miss">Miss</option>
                  <option value="ms">Ms</option>
                  <option value="sir">Sir</option>
                  <option value="dr">Dr</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-xs px-2">
                  <i class="fas fa-chevron-down"></i>
                </div>
              </div>
            </div>

            <div class="px-1 w-full md:w-1/3 flex-grow">
              <label class="block text-xs font-bold mb-2" for="first-name">
                First Name <span class="text-red-500">*</span>
              </label>
              <ValidationProvider
                rules="required"
                name="first name"
                v-slot="{ errors }"
              >
                <input
                  name="first_name"
                  type="text"
                  id="first-name"
                  class="form-control"
                  v-model="contact.first_name"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="px-1 w-full md:w-1/3 flex-grow">
              <label class="block text-xs font-bold mb-2" for="last-name">
                Last Name <span class="text-red-500">*</span>
              </label>

              <ValidationProvider
                rules="required"
                name="last name"
                v-slot="{ errors }"
              >
                <input
                  name="last_name"
                  type="text"
                  id="last-name"
                  class="form-control"
                  v-model="contact.last_name"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap justify-between items-end mt-4">
            <div class="flex flex-wrap -mx-2">
              <div class="px-2 flex items-center select-none">
                <input type="radio" id="radio-gender-male" value="male" name="gender" v-model="contact.gender">
                <label class="ml-1 font-bold" for="radio-gender-male">Male</label>
              </div>
              <div class="px-2 flex items-center select-none">
                <input type="radio" id="radio-gender-female" value="female" name="gender" v-model="contact.gender">
                <label class="ml-1 font-bold" for="radio-gender-female">Female</label>
              </div>
            </div>
            <div class="text-right">
              <label class="block font-bold flex items-center select-none cursor-pointer">
                <input class="mr-1" type="checkbox" v-model="showCompanyName">
                <span class="text-sm">Company</span>
              </label>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 mt-4" v-if="showCompanyName">
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="company-name">
                Company Name
              </label>
              <input type="text" id="company-name" class="form-control" v-model="contact.company_name">
            </div>
            <div class="w-full md:w-1/2 px-2">
              <label class="block text-xs font-bold mb-2" for="vat-number">
                VAT number
              </label>
              <input type="text" id="vat-number" class="form-control" v-model="contact.vat_number">
            </div>
          </div>

          <div class="mt-4">
            <label class="block text-xs font-bold mb-2" for="phone-country">
              Email
            </label>

            <ValidationProvider
              rules="email"
              name="email"
              v-slot="{ errors }"
            >
              <input
                name="email"
                type="text"
                id="email"
                class="form-control"
                v-model="contact.email"
              >
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <p class="text-lg font-bold mt-8">ADDRESS</p>

          <div class="mt-2">
            <div v-for="(addr, i) in contact.addresses" :key="i + 'address'">
              <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                  <label class="block text-xs font-bold mb-2" for="address-country">
                    Country <span class="text-red-500">*</span>
                  </label>

                  <ValidationProvider
                    rules="required"
                    name="country"
                    v-slot="{ errors }"
                  >
                    <div class="relative">
                      <select
                        class="form-control pr-8"
                        name="country"
                        id="address-country"
                        v-model="addr.country_id"
                      >
                        <option value="">Select</option>
                        <option :value="c.id" v-for="(c, i) in Countries" :key="i + 'address-countries'">{{ c.name }}</option>
                      </select>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-xs px-2">
                        <i class="fas fa-chevron-down"></i>
                      </div>
                    </div>
                    <span class="text-sm text-red-500">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="w-full md:w-1/2 px-2">
                  <label class="block text-xs font-bold mb-2" for="city">
                    City <span class="text-red-500">*</span>
                  </label>
                  <ValidationProvider
                    rules="required"
                    name="city"
                    v-slot="{ errors }"
                  >
                    <input
                      name="city"
                      type="text"
                      id="city"
                      class="form-control"
                      v-model="addr.city"
                    >
                    <span class="text-sm text-red-500">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="mt-4">
                <label class="block text-xs font-bold mb-2" for="address-1">
                  Address <span class="text-red-500">*</span>
                </label>
                <ValidationProvider
                  tag="div"
                  rules="required"
                  name="address"
                  v-slot="{ errors }"
                >
                  <textarea
                    name="address_1"
                    class="form-control"
                    id="address-1"
                    rows="3"
                    v-model="addr.address_1"
                  ></textarea>
                  <span class="text-sm text-red-500">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="flex flex-wrap -mx-2 mt-4">
                <div class="w-full md:w-1/2 px-2">
                  <label class="block text-xs font-bold mb-2" for="state">
                    State
                  </label>
                  <input type="text" id="state" class="form-control" v-model="addr.state">
                </div>
                <div class="w-full md:w-1/2 px-2">
                  <label class="block text-xs font-bold mb-2" for="post-code">
                    Post Code <span class="text-red-500">*</span>
                  </label>

                  <ValidationProvider
                    rules="required"
                    name="post code"
                    v-slot="{ errors }"
                  >
                    <input
                      name="post_code"
                      type="text"
                      id="post-code"
                      class="form-control"
                      v-model="addr.post_code"
                    >
                    <span class="text-sm text-red-500">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div class="w-full md:w-1/2 px-2 flex flex-col justify-between">
        <div class="box">
          <p class="text-lg font-bold">PHONE NUMBERS</p>

          <div class="mb-3" v-for="(phone, i) in contact.phone_numbers" :key="i + 'phone'">
            <div class="box py-2 pb-3 px-3 border border-purple">
              <div class="flex flex-wrap justify-between">
                <span class="font-bold" :class="phone.type === 'primary' ? 'text-red-500' : 'text-theme-darker light:text-theme-lighter'">{{ phone.type }}</span>
                <div v-if="i > 0">
                  <a class="btn text-red-500" @click="makePhonePrimary(i)" title="make primary">
                    <i class="fas fa-level-up-alt"></i>
                  </a>
                  <a class="btn" @click="removePhone(i, phone)" title="delete">
                    <i class="fas fa-times"></i>
                  </a>
                </div>
              </div>

              <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                  <label class="block text-xs font-bold mb-2" for="phone-country">
                    Country <span class="text-red-500">*</span>
                  </label>
                  <ValidationProvider
                    rules="required"
                    name="phone country"
                    v-slot="{ errors }"
                  >
                    <div class="relative">
                      <select
                        class="form-control pr-8"
                        :name="'phone-country-' + (i + 1)"
                        id="phone-country"
                        v-model="phone.country_id"
                        @change="validate()"
                      >
                        <option>Select</option>
                        <option :value="c.id" v-for="(c, i) in Countries" :key="i + 'phone-countries'">{{ c.name }} (+{{ c.calling_code }})</option>
                      </select>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-xs px-2">
                        <i class="fas fa-chevron-down"></i>
                      </div>
                    </div>
                    <span class="text-sm text-red-500">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="w-full md:w-1/2 px-2">
                  <label class="block text-xs font-bold mb-2" for="description">
                    Description
                  </label>
                  <ValidationProvider
                    name="description"
                    v-slot="{ errors }"
                  >
                    <input
                      :name="'description-' + (i + 1)"
                      type="text"
                      id="description"
                      class="form-control"
                      v-model="phone.description"
                    >
                    <span class="text-sm text-red-500">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="mt-4">
                <label class="block text-xs font-bold mb-2" for="phone-country">
                  Number <span class="text-red-500">*</span>
                </label>

                <ValidationProvider
                  :rules="{
                    required: true,
                    phone_number: phone
                  }"
                  name="phone number"
                  v-slot="{ errors }"
                >
                  <input
                    :name="'phone-number-' + (i + 1)"
                    type="text"
                    id="number"
                    class="form-control"
                    v-model="phone.number"
                    autocomplete="off"
                  >
                  <span class="text-sm text-red-500">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="text-right">
            <button
              type="button"
              class="btn btn-purple py-2 px-4"
              @click="addPhone"
            >
              <i class="fas fa-plus"></i>
              <span class="ml-3">New phone</span>
            </button>
          </div>

        </div>
        <div class="box flex flex-wrap justify-end items-center">
          <button
            type="button"
            class="btn btn-reset"
            @click="reset"
          >
            <i class="fa-xs fas fa-undo"></i>
            <span class="ml-1">RESET</span>
          </button>
          <button
            type="button"
            class="btn btn-save"
            @click="save"
          >
            <i class="fa-xs fas fa-check"></i>
            <span class="ml-2">{{ mode === 'edit' ? 'UPDATE' : 'SAVE' }}</span>
          </button>
        </div>
      </div>
    </div>
  </ValidationObserver>

</div>
</template>

<script>
import axios from 'axios'
import path from 'path'
import { mapGetters } from 'vuex'

export default {
  name: 'contact-edit',
  props: {
    contactID: {},
    manualContactType: {
      type: String,
      default: 'customer',
    },
    createAlert: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mode: null,
      editID: null,
      showCompanyName: false,
      contact: {},
    }
  },
  mounted() {
    this.setMode()
  },
  watch: {
    'contact.phone_numbers': {
      handler(pn) {
        for (let i in pn) {
          pn[i].country_data = this.CountryByID(pn[i].country_id)
        }
      },
      deep: true
    },
    'contact.company_name'(c) {
      this.showCompanyName = c !== '' && c !== null
    },
    contactID() {
      this.setMode()
    }
  },
  computed: {
    contactType() {
      const name = this.$route.name.split('.')
      let contactType = this.manualContactType
      if (['contact', 'supplier', 'customer'].indexOf(name[0]) !== -1) {
        contactType = name[0]
      }
      return contactType
    },
    ...mapGetters({
      config: 'config/config',
      Countries: 'countries/countries',
      CountryByID: 'countries/countryByID',
    })
  },
  methods: {
    async validate() {
      await this.$refs.observer.validate()
    },
    setMode() {
      const name = this.$route.name.split('.')
      if (['contact', 'supplier', 'customer'].indexOf(name[0]) !== -1 && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.contactID) {
        this.editID = this.contactID
        this.mode = 'edit'
      } else if (this.$route.params.contactID) {
        this.editID = this.$route.params.contactID
        this.mode = 'edit'
      }

      if (this.mode === 'create') {
        this.contact = this.emptyContact()
        this.addAddress()
        this.addPhone()
      } else {
        // get contact
        this.get()
      }
    },
    set(contact) {
      this.contact.first_name = this.$options.filters.sentenceCase(contact.first_name)
      this.contact.last_name = this.$options.filters.sentenceCase(contact.last_name)
    },
    emptyContact() {
      return {
        title: '',
        first_name: '',
        last_name: '',
        company_name: '',
        vat_number: '',
        gender: '',
        email: '',
        addresses: [],
        phone_numbers: [],
      }
    },
    get() {
      if (!this.editID) {
        return false
      }
      return new Promise((resolve, reject) => {
        axios.get(path.join(this.config.endpoints[this.contactType], String(this.editID)))
          .then((response) => {
            const contact = response.data

            // sort by type (primary first)
            contact.phone_numbers.sort((a) => {
              return a.type === 'primary' ? -1 : 1
            })

            this.contact = Object.assign({}, contact)
            if (this.contact.addresses.length <= 0) {
              this.addAddress()
            }

            resolve(contact)
          })
          .catch((error) => reject(error))
      })
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            if (this.mode === 'create') {
              this.contact = this.emptyContact()
              this.addAddress()
              this.addPhone()
            } else {
              this.get()
            }
          }
        })
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      // create / update
      if (this.mode === 'create') {
        axios.post(this.config.endpoints[this.contactType], this.contact)
          .then((response) => {
            const newContact = response.data

            // reset contact (for when modals re-open)
            this.contact = Object.assign({}, this.emptyContact())
            this.addAddress()
            this.addPhone()
            this.$emit('created', newContact)

            if (this.createAlert) {
              this.$swal.fire({
                title: 'Done',
                text: this.$options.filters.sentenceCase(this.contactType) + ' created successfully!',
                type: 'success',
                confirmButtonText: 'Show me',
                showCancelButton: true,
                cancelButtonText: 'Create more',
              })
                .then((result) => {
                  if (result.value) {
                    this.$router.push(path.join('/', this.contactType, 'details', String(newContact.id)))
                  }
                })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.mode === 'edit') {
        // delete company_name and vat_number if showCompanyName is unchecked
        if (!this.showCompanyName) {
          this.contact.company_name = null
          this.contact.vat_number = null
        }
        axios.put(path.join(this.config.endpoints[this.contactType], String(this.contact.id)), this.contact)
          .then(() => {
            this.$swal.fire({
              title: 'Done',
              text: this.$options.filters.sentenceCase(this.contactType) + ' updated successfully!',
              type: 'success',
            })

            // Reminder: Need to refresh data. eg: company name and VAT are deleted
            // automatically based on checkbox value. Note that they are only
            // deleted before update and not on checkbox change
            // Even if it's convenient to leave previous values there, and not
            // refresh it is not correct.
            this.get()
              .then((contact) => {
                this.$emit('updated', contact)
              })
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    makePhonePrimary(index) {
      this.contact.phone_numbers.unshift(this.contact.phone_numbers.splice(index, 1)[0])
      this.contact.phone_numbers = this.contact.phone_numbers.map((p, i) => {
        p.type = i === 0 ? 'primary' : 'secondary'
        return p
      })
    },
    removePhone(index, phone) {
      if(Object.prototype.hasOwnProperty.call(phone, 'reminders') && phone.reminders.length > 0){
        this.$swal.fire({
          title: 'Unable to remove',
          text: 'This phone number has been used in a reminder',
          type: 'warning',
          showCancelButton: false,
        }).then()

        return false
      }

      this.$set({}, this.contact.phone_numbers, this.contact.phone_numbers.splice(index, 1))
    },
    addPhone() {
      const type = this.contact.phone_numbers.length === 0 ? 'primary' : 'secondary'
      this.contact.phone_numbers.push({
        type: type,
        number: '',
        description: '',
        country_id: '196',
      })
    },
    addAddress() {
      this.contact.addresses.push({
        type: 'primary',
        address_1: '',
        address_2: '',
        city: '',
        state: '',
        country_id: '196',
        post_code: '',
      })
    }
  }

}
</script>
